const SelectArrow = {
	template: `
			<span class="salescenter-app-payment-by-sms-item-container-select-arrow" /> 
`
};
export {
	SelectArrow
}